import { useEffect, useRef } from 'react';

// Returning to the tab fires both focus and visibilitychange; one call covers both.
const RETURN_REFRESH_WINDOW_MS = 1000;

/** Calls `onReturn` once each time the user comes back to this tab. */
export const useRefreshOnReturn = (onReturn: () => void) => {
  const onReturnRef = useRef(onReturn);
  useEffect(() => {
    onReturnRef.current = onReturn;
  }, [onReturn]);
  useEffect(() => {
    let lastRefreshAt = 0;
    const onVisible = () => {
      if (document.visibilityState !== 'visible') return;
      const now = Date.now();
      if (now - lastRefreshAt < RETURN_REFRESH_WINDOW_MS) return;
      lastRefreshAt = now;
      onReturnRef.current();
    };
    window.addEventListener('focus', onVisible);
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      window.removeEventListener('focus', onVisible);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, []);
};
